import LecturePrototypeModuleListModelBase from '../_generated/modelBases/lecture-prototype-module-list-model-base';

export default class LecturePrototypeModuleListModel extends LecturePrototypeModuleListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
